// src/components/RegistrationModal.js
import React, { useState, useEffect } from 'react';

const RegistrationModal = ({ isOpen, onClose, onRegister, initialData = {} }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [pix, setPix] = useState('');
  const [password, setPassword] = useState('');
  const [accessCode, setAccessCode] = useState(''); 
  const [error, setError] = useState('');
  const [googleId, setGoogleId] = useState('');

  useEffect(() => {
    // Pré-preenche os campos com dados iniciais, se fornecidos
    if (initialData) {
      setUsername(initialData.name || '');
      setEmail(initialData.email || '');
      setGoogleId(initialData.googleId || '');
    }
  }, [initialData]);

  const handleRegister = async () => {
      const userData = {
        username,
        email,
        phone,
        pix,
        access_code: accessCode,
        googleId,
        ...(googleId ? {} : { password }), // Inclui a senha apenas se googleId não estiver presente
      };

      try {
        const response = await fetch('https://api2.apploja.com/smssender/cadastro_usuario.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userData),
        });
        const result = await response.json();

        if (result.status === 'success') {
          localStorage.setItem('userName', username);
          localStorage.setItem('email', email);

          // Realiza o login automaticamente
          const loginData = googleId ? { email, googleId } : { email, password };
          const loginResponse = await fetch('https://api2.apploja.com/smssender/login_usuario.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(loginData),
          });
          const loginResult = await loginResponse.json();

          if (loginResult.status === 'success') {
            const { token, username } = loginResult;
            localStorage.setItem('token', token);
            localStorage.setItem('username', username);
            onRegister(username);
            onClose(); // Fecha o modal de cadastro
          } else {
            setError('Erro ao realizar login após o cadastro.');
          }
        } else {
          setError(result.message || 'Erro no cadastro. Verifique os dados e tente novamente.');
        }
      } catch (error) {
        setError('Erro ao conectar com o servidor.');
      }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Cadastro de Usuário</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <input
          type="text"
          placeholder="Nome de usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full mb-2 p-2 border rounded"
        />
        {!googleId && (
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
        )}
        <input
          type="text"
          placeholder="Telefone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full mb-2 p-2 border rounded"
        />
        <input
          type="text"
          placeholder="Pix"
          value={pix}
          onChange={(e) => setPix(e.target.value)}
          className="w-full mb-2 p-2 border rounded"
        />
        {!googleId && (
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-2 p-2 border rounded"
          />
        )}
        <input
          type="text"
          placeholder="Código de Acesso"
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
          className="w-full mb-4 p-2 border rounded"
        />
        <button onClick={handleRegister} className="w-full bg-blue-500 text-white p-2 rounded">Cadastrar</button>
        <button onClick={onClose} className="w-full mt-2 text-gray-500 p-2">Fechar</button>
      </div>
    </div>
  );
};

export default RegistrationModal;
